// libs
import React, { memo, useContext, useMemo } from 'react';
import { styled } from '@nykaa/ui-components';
import get from 'lodash/get';

// defs
import { ILandingPageWidget } from 'shared/components/AdPlatformWidgets/types';

// context
import ResponsiveContext from 'shared/components/ResponsiveLoader/ResponsiveContext';

// components
import WidgetTitle from 'shared/components/AdPlatformWidgets/components/WidgetTitle';
import Image from 'shared/components/Image';
import WidgetCarousel from 'shared/components/AdPlatformWidgets/Desktop/components/GenericCarousel';

// helpers
import { getWidgetItemParams } from 'shared/components/AdPlatformWidgets/Desktop/components/GenericCarousel/helpers';
import { generateInFocusParams } from './helpers';

// styles
import { DWEB_MAX_WIDTH } from 'shared/styles/base';
import { Container, InFocusContainer, Anchor } from './styles';

// constants
import { CAROUSEL_TYPES } from 'shared/components/AdPlatformWidgets/Desktop/components/GenericCarousel/constants';

interface IInFocusProps {
  widget: ILandingPageWidget;
}

const InFocusCarousel = styled(WidgetCarousel)`
  display: flex;
  align-items: center;
  position: absolute;
  right: 0;
`;

function InFocus({ widget }: IInFocusProps) {
  const { deviceWidth } = useContext(ResponsiveContext);

  const carouselType = CAROUSEL_TYPES.WIDGETS;
  const containerWidth = deviceWidth > DWEB_MAX_WIDTH ? DWEB_MAX_WIDTH : deviceWidth;

  const { title, inFocusBanner, inFocusData, titleAligment } = useMemo(
    () => generateInFocusParams(widget),
    [widget]
  );

  const inFocusBannerData = getWidgetItemParams(
    inFocusBanner,
    containerWidth,
    widget.inventory_name
  );

  const { action_url } = inFocusBannerData;

  const ImageComponent = (
    <Image
      src={inFocusBannerData.source}
      width={containerWidth}
      aspectRatio={inFocusBannerData.aspect_ratio}
      alt={title}
    />
  );

  const WRAPPED_IMAGE = action_url ? (
    <Anchor target="_blank" href={action_url}>
      {ImageComponent}
    </Anchor>
  ) : (
    ImageComponent
  );

  const marginTop = get(widget, 'widget_data.parameters.margin_top');
  return (
    <Container marginTop={marginTop}>
      {title && <WidgetTitle title={title} alignment={titleAligment} />}
      <InFocusContainer>
        {WRAPPED_IMAGE}
        <InFocusCarousel
          carouselType={carouselType}
          widgets={inFocusData}
          containerWidth={containerWidth * 0.5}
        />
      </InFocusContainer>
    </Container>
  );
}

export default memo(InFocus);
